import { CreateListingAddPickupAddress } from '../../../components/create-listing-add-pickup-address/CreateListingAddPickupAddress';

export const CreateListingAddPickupAddressView = () => <CreateListingAddPickupAddress />;
